import React from 'react';
import { useLocation } from 'react-router-dom';
import Footer from './Footer';

interface PageWithFooterProps {
  children: React.ReactNode;
}

const PageWithFooter: React.FC<PageWithFooterProps> = ({ children }) => {
  const location = useLocation();
  
  // Pages where footer should NOT be shown
  const excludedPaths = [
    '/dashboard',
    '/upgrade',
    '/admin/country-pricing',
    '/payment-success'
  ];
  
  // Check if current path matches excluded paths or assessment ID pattern
  const shouldShowFooter = !excludedPaths.includes(location.pathname) && 
                          !location.pathname.match(/^\/assessment\/[^/]+$/);
  
  return (
    <>
      {children}
      {shouldShowFooter && <Footer />}
    </>
  );
};

export default PageWithFooter;